import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import SmartphoneOutlinedIcon from "@mui/icons-material/SmartphoneOutlined";
import LandingSectionHeader from "./LandingSectionHeader";
import { MessengerBrandInline } from "./MessengerBrandIcons";
import "./LandingPlatformSection.css";

const PILLARS = [
  {
    icon: <MenuBookOutlinedIcon />,
    accent: "kb",
    title: "Подсказки на смене",
    desc: "База знаний — ответ на рабочий вопрос за секунду, когда наставника рядом нет.",
  },
  {
    icon: <AccountTreeOutlinedIcon />,
    accent: "scenario",
    title: "Обучение через решения",
    desc: "Сценарий — сотрудник проходит ситуацию шаг за шагом и видит последствия выбора.",
  },
  {
    icon: <QuizOutlinedIcon />,
    accent: "trainer",
    title: "Проверка и рост",
    desc: "Тренажёр — закрепление знаний с мгновенной обратной связью и рейтингом команды.",
  },
  {
    icon: <EmojiEventsOutlinedIcon />,
    accent: "game",
    title: "Мотивация в игровой форме",
    desc: "Рейтинг, ачивки и акции — например, первое место в тренажёре за месяц и приз от HR.",
  },
];

export default function LandingPlatformSection() {
  return (
    <section
      id="about"
      className="landing-band landing-band--about landing-section landing-section--about"
    >
      <div className="landing-container">
        <LandingSectionHeader
          label="01 · О сервисе"
          title="Что такое MOGAME"
          desc="Платформа для HR и руководителей: вы готовите материалы в браузере, команда проходит их в Telegram или MAX — без отдельных приложений и сложной LMS."
        />

        <div className="landing-band__panel landing-band__panel--about">
          <div className="landing-platform-intro">
            <p className="landing-platform-intro__lead">
              MOGAME объединяет <strong>обучение</strong>, <strong>подсказки на
              работе</strong> и <strong>развитие в игровой форме</strong>. HR
              собирает программу за минуты, публикует ссылку — сотрудники учатся
              там, где уже общаются каждый день.
            </p>
            <div className="landing-platform-intro__messengers">
              <MessengerBrandInline size={28} spaced />
              <span>Telegram и MAX — без регистрации и паролей для команды</span>
            </div>
          </div>

          <div className="landing-platform-pillars">
            {PILLARS.map(({ icon, accent, title, desc }) => (
              <article
                className={`landing-platform-pillar landing-platform-pillar--${accent}`}
                key={title}
              >
                <div className="landing-platform-pillar__icon">{icon}</div>
                <h3 className="landing-platform-pillar__title">{title}</h3>
                <p className="landing-platform-pillar__desc">{desc}</p>
              </article>
            ))}
          </div>

          <div className="landing-platform-gamification">
            <div className="landing-platform-gamification__icon">
              <EmojiEventsOutlinedIcon />
            </div>
            <div>
              <h3 className="landing-platform-gamification__title">
                Развитие и вовлечение — не только тесты
              </h3>
              <p className="landing-platform-gamification__desc">
                Устраивайте акции: «Займи первое место в тренажёре за месяц —
                получи приз», отмечайте лидеров ачивками, поощряйте прохождение
                сценариев. Сотрудники видят рейтинг в боте — это мотивирует
                сильнее, чем формальный отчёт в Excel.
              </p>
            </div>
            <div className="landing-platform-gamification__phone">
              <SmartphoneOutlinedIcon />
              <span>Рейтинг и ачивки — прямо в мессенджере</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
